import { render, staticRenderFns } from "./CreateVehiclePage.vue?vue&type=template&id=32ef8ff8"
import script from "./CreateVehiclePage.vue?vue&type=script&lang=js"
export * from "./CreateVehiclePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports